export { default } from './CurationBanner';
